export default __webpack_public_path__ + "static/media/Narmada-Udgam-and-Kund.dd8c29bd.jpg";